import IframeDialog from './iframeDialog.vue';
import Vue from 'vue';

// 选择器封装模式1
export default function (uicfg, selected, options, callback) {
  // 创建构造器
  let instance;
  window.selopen2(selected, options, (rt, isCancel) => {
    //选择完成后，关闭弹出层
    instance.close();
    if (!isCancel && rt) {
      callback(rt);
    }
  },
    function (url) {
      //使用自己的弹出层，展示角色选择器
      let cfg = Object.assign({}, { url }, uicfg);

      // 创建实例
      let IframeDialogConstructor = Vue.extend(IframeDialog);
      instance = new IframeDialogConstructor({
        data: { cfg, }
      }).$mount();

      document.body.appendChild(instance.$el);
    });
}
